export default ":is([part=button-prev],[part=button-next]){transition:opacity var(--icf-transition-base);&[aria-disabled=true]{opacity:0}>svg{display:none}}";